import { createAction, props } from '@ngrx/store';
import { SourcingOutcomeInformation } from 'src/app/shared/models/app-models/SourcingOutcome.model';

export const updateRFQSummaryData = createAction(
    '[RFQ Summary] Update RFQ Summary Data',
    props<{ rfqSummary: SourcingOutcomeInformation }>()
);

export const updateRoName = createAction(
    '[RFQ Summary] Update RoName',
    props<{ ROName: string }>()
);

export const updatePeName = createAction(
    '[RFQ Summary] Update PeName',
    props<{ AssignedPE: string }>()
);

export const updateDocumentStatusId = createAction(
    '[RFQ Summary] Update document status',
    props<{ DocumentStatusId: number }>()
);

export const resetDocument = createAction('[RFQ Summary] Reset Document');

export const UpdatePOCreated = createAction(
    '[RFQ Summary] Update arePOCreated',
    props<{ arePOCreated: boolean }>()
);
